import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdOptions } from '@onefootprint/fetch-dashboard';
import type { ApiError, VaultKind } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';
import { ErrorComponent } from '@/components';
import Page404 from '@/components/404';
import Content from './components/content';
import Loading from './components/loading';
import TenantSwitcher from './components/tenant-switcher';
import useEntityId from './hooks/use-entity-id';
import useEntityInitialData from './hooks/use-entity-initial-data';
type DetailsProps = {
  kind: VaultKind;
};
const Details = t0 => {
  const $ = _c(11);
  const {
    kind
  } = t0;
  const id = useEntityId();
  let t1;
  if ($[0] !== id) {
    t1 = getEntitiesByFpIdOptions({
      path: {
        fpId: id
      }
    });
    $[0] = id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data,
    isPending,
    error
  } = useQuery(t1);
  useEntityInitialData();
  if (isPending) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Loading />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (data && data.kind !== kind) {
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Page404 />;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (error) {
    let t2;
    if ($[4] !== error) {
      t2 = <ErrorComponent error={error} />;
      $[4] = error;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    let errorComponent = t2;
    if ((error as unknown as ApiError)?.status === 404) {
      let t3;
      if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = <Page404 />;
        $[6] = t3;
      } else {
        t3 = $[6];
      }
      errorComponent = t3;
    }
    let t3;
    if ($[7] !== errorComponent || $[8] !== id) {
      t3 = <TenantSwitcher entityId={id} Loading={Loading}>{errorComponent}</TenantSwitcher>;
      $[7] = errorComponent;
      $[8] = id;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    return t3;
  }
  let t2;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <EntityDetails />;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
const EntityDetails = () => {
  const $ = _c(13);
  const {
    isPending,
    error,
    data
  } = useEntityInitialData();
  let t0;
  if ($[0] !== isPending) {
    t0 = isPending && <Loading />;
    $[0] = isPending;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== error || $[3] !== isPending) {
    t1 = error && !isPending && <ErrorComponent error={error} />;
    $[2] = error;
    $[3] = isPending;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== data || $[6] !== isPending) {
    t2 = data && !isPending && <Content kind={data.kind} />;
    $[5] = data;
    $[6] = isPending;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== isPending || $[9] !== t0 || $[10] !== t1 || $[11] !== t2) {
    t3 = <div aria-busy={isPending}>{t0}{t1}{t2}</div>;
    $[8] = isPending;
    $[9] = t0;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
};
export default Details;